<template>
  <div>
    <span class="mb-1 text-xs text-gray-500">Description</span>
    <p class="mb-0 text-s text-gray-700">{{ landscape.description }}</p>
  </div>
</template>
<script>
export default {
  name: 'LandscapeDescription',
  props: {
    landscape: {
      type: Object,
      required: true
    }
  }
}
</script>
